var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBadgeBackground = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 130.15 144.99",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;opacity:.4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M119.58,28.44L75.68,2.86c-6.54-3.81-14.66-3.81-21.2,0L10.58,28.44C4.05,32.24,0,39.32,0,46.91v51.16c0,7.59,4.05,14.67,10.58,18.47l43.9,25.58c3.27,1.9,6.93,2.86,10.6,2.86s7.33-.95,10.6-2.86l43.9-25.58c6.52-3.8,10.57-10.88,10.57-18.47V46.91c0-7.59-4.05-14.67-10.58-18.47Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBadgeBackground, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BadgeBackground.cf53e86d.svg";
export { ForwardRef as ReactComponent };